import { ReactElement, cloneElement, CSSProperties,
  useCallback, useRef, useEffect, useState } from 'react'
import "./SlideOpenClose.scss"

type Props = {
  isOpen: boolean
  children: ReactElement
}

export function SlideOpenClose({isOpen, children}: Props): ReactElement {
  const [slidingItemHeight, setSlidingItemHeight] =
    useState<number|undefined>(undefined)
  const slidingItem = useRef<HTMLElement>()

  const fixSlideItemHeight = useCallback(() => {
    if (!slidingItem.current) {
      return
    }
    setSlidingItemHeight(slidingItem.current.scrollHeight)
  }, [])

  useEffect(() => {
    if (!slidingItem.current) {
      return
    }
    const observer  = new MutationObserver(fixSlideItemHeight)
    const config = { attributes: false, childList: true, subtree: true,
      characterData: true};
    observer.observe(slidingItem.current, config)
    return () => observer.disconnect()
  }, [fixSlideItemHeight])

  useEffect(() => {
    window.addEventListener("resize", fixSlideItemHeight)
    return () => window.removeEventListener("resize", fixSlideItemHeight)
  }, [fixSlideItemHeight])

  useEffect(() => {
    fixSlideItemHeight()
  }, [fixSlideItemHeight, isOpen])

  const style = {"--slidingItemHeight": `${slidingItemHeight}px`} as CSSProperties

  return cloneElement(children, {
    ref: (ref: HTMLElement) => slidingItem.current = ref,
    style: {...("style" in children.props ? children.props.style : {}), ...style},
    className: ("className" in children.props ? children.props.className + " " : "")
    + "SlideOpenClose_" + (isOpen ? "Open" : "Close"),
  })
}
